import { Icons } from '@clientbase/clientbase-library'
import { Stack, Typography } from '@mui/material'

import IconContainer from 'components/IconContainer/IconContainer'

import logError from 'utils/errorLogger'

export const getHoverText = (status: string) => {
  switch (status) {
    case 'analysing':
      return {
        text: <p>Negativação aprovada e enviada</p>
      }
    case 'processing':
      return {
        text: <p>Negativação aprovada e enviada</p>
      }
    case 'waiting_return':
      return {
        text: <p>Negativação em processamento</p>
      }
    case 'negativated':
      return {
        text: <p>Negativação efetuada com sucesso</p>
      }
    case 'recovering': {
      return {
        text: (
          <p>
            Negativação foi sinalizada como recuperada e está aguardando o
            processamento
          </p>
        )
      }
    }
    case 'recovered': {
      return {
        text: <p>Negativação recuperada com sucesso</p>
      }
    }
    case 'cancelling': {
      return {
        text: <p>O cancelamento da negativação está sendo processado</p>
      }
    }
    case 'cancelled': {
      return {
        text: <p>Negativação cancelada</p>
      }
    }
    case 'failed': {
      return {
        text: <p>Ocorreu um problema ao negativar a cobrança</p>
      }
    }
    default:
      // Sem status a negativação ainda está carregando: não é status desconhecido.
      if (status) {
        logError(`Erro ao mapear o texto da tooltip de negativação: ${status}`)
      }

      return {
        text: <p>Status desconhecido</p>
      }
  }
}

export function renderTitle(label: string, icon: Icons, main?: boolean) {
  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <IconContainer icon={icon} />
      <Typography variant={main ? 'mdBold' : 'smLight'}>{label}</Typography>
    </Stack>
  )
}
